<template>
  <div class="space-y-6">
    <Card padding="none">
      <template #header>
        <div class="px-6 py-4 flex justify-between items-center">
          <h3 class="text-lg font-medium text-text">Pending Invites</h3>
          <Button size="sm" @click="$emit('invite')">New Invite</Button>
        </div>
      </template>

      <div class="overflow-x-auto">
        <Table
          :columns="[
            { key: 'email', label: 'Email' },
            { key: 'role', label: 'Role' },
            { key: 'expires', label: 'Expires' },
            { key: 'actions', label: '' },
          ]"
          :rows="invites"
        >
          <template #cell-role="{ row: invite }">
            <span
              class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300"
            >
              {{ invite.role }}
            </span>
          </template>
          <template #cell-expires="{ row: invite }">
            {{ new Date(invite.expires_at).toLocaleDateString() }}
          </template>
          <template #cell-actions="{ row: invite }">
            <div class="text-right">
              <button
                v-if="isAdmin"
                @click="cancelInvite(invite.id)"
                class="text-danger-600 hover:text-danger-900"
              >
                Cancel
              </button>
            </div>
          </template>
        </Table>
      </div>

      <div v-if="loading" class="px-6 py-10 flex justify-center">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>

      <div
        v-if="!loading && invites.length === 0"
        class="px-6 py-10 text-center text-gray-500 dark:text-gray-400"
      >
        No pending invites.
      </div>
    </Card>
  </div>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';
  import { useOrganizationInvites, useOrganizationPermissions } from '../composables';
  import { Card, Button, Table } from '@asabdev/asab-ui';

  defineEmits<{
    (e: 'invite'): void;
  }>();

  const {
    invitations: invites,
    isLoading: loading,
    fetchInvitations: fetchInvites,
    cancelInvitation: cancelInvite,
  } = useOrganizationInvites();
  const { isAdmin } = useOrganizationPermissions();

  onMounted(() => {
    fetchInvites();
  });
</script>
